var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.iPhoneX-bottom {\n  padding-bottom: 34px !important;\n}\n@font-face {\n  font-family: suiguanjia;\n  src: url(" + escape(require("../../static/font/Suiguanjia-Medium.otf")) + ");\n}\n.ui-container {\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  /*overflow: scroll;*/\n  -webkit-overflow-scrolling: touch;\n  position: absolute;\n  left: 0;\n  top: 0;\n  max-width: 640px;\n  margin: 0 auto;\n}\n.container {\n  min-height: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-9dbac6b0","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/App.vue
// module id = 136
// module chunks = 8